export const METRIC_DATA_TYPES = {
    PERCENTAGE: 'percentage',
    NUMBER: 'number',
};
